import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {z as r} from 'zod';

import {fetchAndDeserialize} from '../../util/api-adapter';

const reviewHistoryValueSchema = r
    .union([r.string(), r.number(), r.boolean()])
    .nullish()
    .transform((value) => value ?? null);

const reviewHistoryItemSchema = r.object({
    date: r.string(),
    field: r.string(),
    newValue: reviewHistoryValueSchema,
    oldValue: reviewHistoryValueSchema,
    reviewId: r.number(),
});

export type ReviewHistoryDataType = r.infer<typeof reviewHistoryItemSchema>;

const reviewHistoryListSchema = r.array(reviewHistoryItemSchema);

function getReviewHistoryListUrl(reviewId: number) {
    return `/v4/reviews/${reviewId}/history/`;
}

async function fetchReviewHistoryList(reviewId: number): Promise<Array<ReviewHistoryDataType>> {
    return fetchAndDeserialize<Array<ReviewHistoryDataType>>(
        getReviewHistoryListUrl(reviewId),
        reviewHistoryListSchema
    );
}

export function useReviewHistoryList(reviewId: number, enabled = true): UseQueryResult<Array<ReviewHistoryDataType>> {
    return useQuery([getReviewHistoryListUrl(reviewId)], () => fetchReviewHistoryList(reviewId), {
        enabled,
        refetchOnWindowFocus: false,
    });
}
